export default __webpack_public_path__ + "static/media/starrepair_2.55f91d65.jpg";